import { IAutoMapper } from "../interfaces";

export const mapBillingItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "BillingItem")
    .forMember("projectId", o => o.projectId)
    .forMember("copyProjectId", o => o.copyProjectId)
    .forMember("retrieval", o => o.retrieval)
    .forMember("costPerRetrieval", o => o.costPerRetrieval)
    .forMember("retrievalEndDate", o => o.retrievalEndDate)
    .forMember("abstraction", o => o.abstraction)
    .forMember("costPerAbstraction", o => o.costPerAbstraction)
    .forMember("abstractionEndDate", o => o.abstractionEndDate);
};
